import { currentUserSelector } from "./currentUserSelector";
import { RootState } from "../store";

export const currentUserEmailSelector = (
  state: RootState,
): string | null | undefined => {
  return currentUserSelector(state)?.email;
};
